/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { pushOneReligion } from "../../../../middlewares/sysNavigation/SysNavigation";
import { useReligionContext } from "../../../../context/religion/ReligionContext";

import { Modal, Button, Search, Pagination } from "../../component/Component";
import { _PAGE_SIZE_ } from "../../../../middlewares/other/tools";

const addRoute = "/religion/add";
const editRoute = "/religion/edit";

const Overview = () => {
  let [religionList, setReligionList] = useState([]);
  const { religion, fetchReligions, count } = useReligionContext();

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(_PAGE_SIZE_);

  useEffect(() => {
    if (!religion) fetchReligions(page, pageSize);
    setReligionList(religion);
  }, [religion]);

  const SearchList = (e) => {
    const key = e.target.value.toString().toLowerCase();
    let searchArray = [];
    if (religion) {
      religion.map((_religion_) => {
        if (_religion_.name.toString().toLowerCase().includes(key))
          return searchArray.push(_religion_);
        return true;
      });
    }
    setReligionList(searchArray);
    if (key === "") setReligionList(religion);
  };

  return (
    <div className="h-full overflow-y-auto bg-gray-50 p-3 lg:p-6">
      <div className="mx-auto max-w-6xl">
        {/* Page header */}
        <div className="mb-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <span className="grid h-10 w-10 place-items-center rounded-xl bg-indigo-100 text-indigo-600">
              {/* book/temple icon */}
              <svg
                viewBox="0 0 24 24"
                className="h-5 w-5"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M4 5a2 2 0 0 1 2-2h7a3 3 0 0 1 3 3v12a1 1 0 0 1-1.447.894L12 17.118l-2.553 1.776A1 1 0 0 1 8 18V6H6a2 2 0 0 1-2-1Z" />
                <path d="M18 4h1a1 1 0 0 1 1 1v13.5a1.5 1.5 0 0 1-2.414 1.2L16 18.5V6a2 2 0 0 1 2-2Z" />
              </svg>
            </span>
            <div>
              <h1 className="text-xl font-semibold leading-tight text-gray-900">
                Religions
              </h1>
              <p className="text-sm text-gray-500">
                Browse, add, edit, and manage religions.
              </p>
            </div>
          </div>
          <span className="hidden rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-700 sm:inline-flex">
            Total: {count ?? 0}
          </span>
        </div>

        {/* Search + Add */}
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
          <div className="sm:col-span-2">
            <Search
              props={{
                title: "Religion",
                onChange: (e) => SearchList(e),
              }}
            />
          </div>
          <div className="w-full sm:justify-self-end">
            <Link to={addRoute}>
              <Button
                props={{
                  type: "button",
                  title: "Add Religion",
                  category: "default",
                  action: "add",
                  onClick: null,
                }}
              />
            </Link>
          </div>
        </div>

        {/* Table card */}
        <div className="mt-5 overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
          <div className="overflow-x-auto">
            <table className="w-full text-left text-sm">
              <thead className="sticky top-0 z-10 bg-gray-50/80 backdrop-blur">
                <tr className="text-gray-600">
                  <th className="w-full border-b border-gray-200 px-4 py-3 font-semibold">
                    <div className="inline-flex items-center gap-2">
                      <svg
                        className="h-4 w-4 text-gray-400"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path d="M5 4h14v2H5zM5 11h14v2H5zM5 18h14v2H5z" />
                      </svg>
                      <span>Name</span>
                    </div>
                  </th>
                  <th className="border-b border-gray-200 px-4 py-3 text-right font-semibold">
                    <div className="inline-flex items-center gap-2">
                      <svg
                        className="h-4 w-4 text-gray-400"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <circle cx="5" cy="12" r="2" />
                        <circle cx="12" cy="12" r="2" />
                        <circle cx="19" cy="12" r="2" />
                      </svg>
                      <span>Actions</span>
                    </div>
                  </th>
                </tr>
              </thead>

              <tbody className="divide-y divide-gray-100">
                {religion ? (
                  (() => {
                    if (!religionList) religionList = [...religion];
                    return religionList.map((_religion_) => (
                      <tr
                        key={_religion_.religion_id}
                        className="odd:bg-white even:bg-gray-50 hover:bg-indigo-50/60 transition-colors"
                      >
                        <td className="px-4 py-3 align-middle text-gray-900">
                          {_religion_.name}
                        </td>
                        <td className="px-4 py-3 align-middle">
                          <div className="flex justify-end">
                            <ActionButton props={_religion_} />
                          </div>
                        </td>
                      </tr>
                    ));
                  })()
                ) : (
                  <tr className="odd:bg-white even:bg-gray-50">
                    <td className="px-4 py-6 text-gray-400">Loading...</td>
                    <td className="px-4 py-6 text-right text-gray-400">
                      Loading...
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Pagination */}
        <div className="mt-4">
          <Pagination
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            total_items={count}
            callbackFunction={(_page_, _pageSize_) => {
              fetchReligions(_page_, _pageSize_);
            }}
          />
        </div>
      </div>
    </div>
  );
};

/**
 *  @author Ntavigwa Bashombe
 * @param {*} props
 * @returns
 */
const ActionButton = ({ props }) => {
  const { religion, updateReligionState, deleteReligion } =
    useReligionContext();

  const [showModal, setShowModal] = useState(false);

  const religion_id = props.religion_id;
  const religion_name = props.name;
  const _religion_ = props;

  const deleteOneReligionById = async (religion_id) => {
    const response = await deleteReligion(religion_id);
    if (response.data.status === 200) {
      if (religion) {
        const update = religion.filter(
          (_religion_) => _religion_.religion_id !== religion_id
        );
        updateReligionState(update);
        setShowModal(false);
      }
    }
  };

  return (
    <>
      <Modal
        props={{
          name: religion_name,
          showModal: showModal,
          setShowModal: () => setShowModal(false),
          delete: () => deleteOneReligionById(religion_id),
        }}
      />

      <div className="flex items-center gap-2 px-0 py-0 sm:px-2 sm:py-2">
        <Link to={editRoute}>
          <Button
            props={{
              type: "button",
              title: "Edit",
              category: "blue",
              action: "edit",
              onClick: () => {
                pushOneReligion(_religion_);
              },
            }}
          />
        </Link>
        <Button
          props={{
            type: "button",
            title: "Delete",
            category: "red",
            action: "delete",
            onClick: () => setShowModal(true),
          }}
        />
      </div>
    </>
  );
};

export default Overview;
